import { ReactNode } from "react";
import { Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/Dialog";
import { cn } from "@/util/cn";

interface InfoDialogProps {
  children: ReactNode;
  title?: string;
  className?: string;
  contentClassName?: string;
  triggerClassName?: string;
}

export default function InfoDialog({
  children,
  title,
  className,
  contentClassName,
  triggerClassName,
}: InfoDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild className={className}>
        <Info className={cn("size-5 cursor-pointer", triggerClassName)} />
      </DialogTrigger>
      <DialogContent
        className={cn(
          "max-w-4xl max-h-[80vh] overflow-y-auto",
          contentClassName
        )}
      >
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        <div className="space-y-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
